export const ZOOM_FACTOR_LIMIT = { min: 0.2, max: 4 };
export const ZOOM_SETTING_STEP = 50;
export const ZOOM_SETTING_DEFAULT = 'auto';
